var map = {
	"./admin-img.png": 659,
	"./banner-icon.svg": 660,
	"./btc.svg": 661,
	"./busd.svg": 662,
	"./dahsboard-icon.svg": 663,
	"./dai.svg": 664,
	"./doge.svg": 665,
	"./games-icon.svg": 666,
	"./image-profile-2.png": 667,
	"./image-profile.png": 668,
	"./logo.svg": 669,
	"./logout-icon.svg": 670,
	"./notification-icon.svg": 671,
	"./reward-icon.svg": 672,
	"./statistics-graph-img.png": 673,
	"./top-games-img-one.png": 674,
	"./top-games-img-three.png": 675,
	"./top-games-img-two.png": 676,
	"./top-videos-img-one.png": 677,
	"./top-videos-img-two.png": 678,
	"./tota-videos-icon.svg": 679,
	"./total-games-icon.svg": 680,
	"./total-transections-icon.svg": 681,
	"./total-users-icon.svg": 682,
	"./user-1.png": 683,
	"./user-icon.svg": 684,
	"./videos-icon.svg": 685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 658;